// El plan de la marca activa, abrible desde cualquier pantalla con
// `abrirPlanDeMarcaOSino()` (ADR-2026-10-28-elegir-plan-de-marca). Va montado una
// vez en la raíz de la app: así la sidebar, la barra de créditos, el visor y los modos no
// necesitan montar cada uno su modal. Sin facturación por marca nadie dispara el evento y
// esto no dibuja nada.

import { useEffect, useState } from 'react';
import ElegirPlanDeMarca from './ElegirPlanDeMarca';
import { EVENTO_ABRIR_PLAN_DE_MARCA } from './abrirPlanDeMarca';
import type { PedidoDePlanDeMarca } from './planDeMarca';

export function HostDelPlanDeMarca() {
  // El último pedido se conserva al cerrar: el modal necesita su marca mientras sale.
  const [pedido, setPedido] = useState<PedidoDePlanDeMarca | null>(null);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    const abrir = (e: Event) => {
      const detalle = (e as CustomEvent<PedidoDePlanDeMarca>).detail;
      if (!detalle) return;
      setPedido(detalle);
      setAbierto(true);
    };
    window.addEventListener(EVENTO_ABRIR_PLAN_DE_MARCA, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_PLAN_DE_MARCA, abrir);
  }, []);

  if (!pedido) return null;
  return (
    <ElegirPlanDeMarca
      abierto={abierto}
      brandId={pedido.brandId}
      modo={pedido.modo}
      onListo={() => setAbierto(false)}
    />
  );
}
